enum SeriesTypes {
  Standard,
  Elite,
  ElitePlus,
  EliteMax,
}

export default SeriesTypes;
